import { render } from "./WindowsAndDoorsView.vue?vue&type=template&id=b90d982a"
import script from "./WindowsAndDoorsView.vue?vue&type=script&lang=js"
export * from "./WindowsAndDoorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__